import cx from "classnames";
import styles from "./BreadcrumbScroll.module.css";
import Link from "next/link";
import { useDetectScroll } from "@smakss/react-scroll-direction";
import HomeIcon from "@mui/icons-material/Home";
import {useEffect, useState} from "react";
import {useRouter} from "next/router";

const BreadcrumbScroll = ({
  title,
  routeOne,
  titleOne,
  routeTwo,
  titleTow,
  routeThree,
  titleThree,
  dark
}) => {
  const [scrollDir] = useDetectScroll({});
  const [isEn, setIsEn] = useState(false)
  const router = useRouter()

  useEffect(() => {
    if (router.pathname.includes("/en")) {
      setIsEn(true)
    } else {
      setIsEn(false)
    }
  }, [router])
  return (
    <div
      className={cx(
        dark? styles.containerDark : styles.container,
        "d-flex",
        "align-items-center",
        "justify-content-between",
        scrollDir !== "down" ? styles.Stick : styles.notStick
      )}
    >
      <h3 className={cx(dark?styles.titleStylesDark:styles.titleStyles, isEn ? styles.gilroyFontFamily : "", "d-none", "d-xxl-flex")}>
        {title?.length > 70 ? `${title?.slice(0, 71)} ...` : title}
      </h3>
      <h3
        className={cx(dark?styles.titleStylesDark:styles.titleStyles, isEn ? styles.gilroyFontFamily : "", "d-none", "d-xl-flex", "d-xxl-none")}
      >
        {title?.length > 60 ? `${title?.slice(0, 61)} ...` : title}
      </h3>
      <h3
        className={cx(dark?styles.titleStylesDark:styles.titleStyles, isEn ? styles.gilroyFontFamily : "", "d-none", "d-lg-flex", "d-xl-none")}
      >
        {title?.length > 40 ? `${title?.slice(0, 41)} ...` : title}
      </h3>
      <h3
        className={cx(dark?styles.titleStylesDark:styles.titleStyles, isEn ? styles.gilroyFontFamily : "", "d-none", "d-md-flex", "d-lg-none")}
      >
        {title?.length > 50 ? `${title?.slice(0, 51)} ...` : title}
      </h3>
      <h3
        className={cx(dark?styles.titleStylesDark:styles.titleStyles, isEn ? styles.gilroyFontFamily : "", "d-none", "d-sm-flex", "d-md-none")}
      >
        {title?.length > 40 ? `${title?.slice(0, 41)} ...` : title}
      </h3>
      <h3 className={cx(dark?styles.titleStylesDark:styles.titleStyles, isEn ? styles.gilroyFontFamily : "", "d-flex", "d-sm-none")}>
        {title?.length > 20 ? `${title?.slice(0, 21)} ...` : title}
      </h3>
      <div className="d-flex align-items-center justify-content-center">
        <span className={cx(isEn ? styles.verticalLineEn : styles.verticalLine, "d-flex")}></span>
        <Link className={cx(styles.linkStyle , isEn ? styles.gilroyFontFamily : "", "d-flex", "mb-sm-1", "mb-0")} href="/">
          <HomeIcon
            sx={{
              color: "#9e9e9e",
              fontSize: "16px",
              transform: "translateY(-1px)",
            }}
          />
        </Link>
        {routeOne && titleOne && (
          <>
            <span className={cx(styles.icon)}>
              <svg
                  style={{
                    transform: isEn ? "rotate(180deg)" : "none"
                  }}
                width="6"
                height="10"
                viewBox="0 0 6 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M5 9L1 5" stroke="#9E9E9E" strokeLinecap="round" />
                <path d="M5 1L1 5" stroke="#9E9E9E" strokeLinecap="round" />
              </svg>
            </span>
            <Link
              className={cx(
                styles.linkStyle, isEn ? styles.gilroyFontFamily : "",
                !routeTwo && !titleTow && styles.activeLink,
                "d-flex",
                "d-lg-none"
              )}
              href={routeOne}
            >
              {titleOne?.length > 15
                ? `${titleOne?.slice(0, 16)} ...`
                : titleOne}
            </Link>
            <Link
              className={cx(
                styles.linkStyle, isEn ? styles.gilroyFontFamily : "",
                !routeTwo && !titleTow && styles.activeLink,
                "d-none",
                "d-lg-flex"
              )}
              href={routeOne}
            >
              {titleOne}
            </Link>
          </>
        )}
        {routeTwo && titleTow && (
          <>
            <span className={cx(styles.icon)}>
              <svg
                  style={{
                    transform: isEn ? "rotate(180deg)" : "none"
                  }}
                width="6"
                height="10"
                viewBox="0 0 6 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M5 9L1 5" stroke="#9E9E9E" strokeLinecap="round" />
                <path d="M5 1L1 5" stroke="#9E9E9E" strokeLinecap="round" />
              </svg>
            </span>
            <Link
              href={routeTwo}
              className={cx(
                styles.linkStyle, isEn ? styles.gilroyFontFamily : "",
                styles.activeLink,
                "d-none",
                "d-xxl-flex"
              )}
            >
              {titleTow?.length > 25
                ? `${titleTow?.slice(0, 26)} ...`
                : titleTow}
            </Link>
            <Link
              href={routeTwo}
              className={cx(
                styles.linkStyle, isEn ? styles.gilroyFontFamily : "",
                styles.activeLink,
                "d-flex",
                "d-xxl-none"
              )}
            >
              {titleTow?.length > 10
                ? `${titleTow?.slice(0, 11)} ...`
                : titleTow}
            </Link>
          </>
        )}
        {routeThree && titleThree && (
            <>
            <span className={cx(styles.icon)}>
              <svg
                  style={{
                    transform: isEn ? "rotate(180deg)" : "none"
                  }}
                  width="6"
                  height="10"
                  viewBox="0 0 6 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M5 9L1 5" stroke="#9E9E9E" strokeLinecap="round" />
                <path d="M5 1L1 5" stroke="#9E9E9E" strokeLinecap="round" />
              </svg>
            </span>
              <Link
                  href={routeThree}
                  className={cx(
                      styles.linkStyle, isEn ? styles.gilroyFontFamily : "",
                      styles.activeLink,
                      "d-none",
                      "d-xxl-flex"
                  )}
              >
                {titleThree?.length > 25
                    ? `${titleThree?.slice(0, 26)} ...`
                    : titleThree}
              </Link>
              <Link
                  href={routeThree}
                  className={cx(
                      styles.linkStyle, isEn ? styles.gilroyFontFamily : "",
                      styles.activeLink,
                      "d-flex",
                      "d-xxl-none"
                  )}
              >
                {titleThree?.length > 10
                    ? `${titleThree?.slice(0, 11)} ...`
                    : titleThree}
              </Link>
            </>
        )}
      </div>
    </div>
  );
};

export default BreadcrumbScroll;
